import { Dispatch, SetStateAction } from 'react'
import { toast } from 'react-toastify'
import { CAI_CHAT_FLOWS } from 'src/constants/cai-chat.constant'
import { Message } from '.'


export const getOrCreateGoalSession = async (
  user_id: string,
  organisation_id: string,
  setFlow: Dispatch<SetStateAction<string>>,
  setCanvasData: Dispatch<SetStateAction<string | null>>,
  setCanvasResponse: Dispatch<SetStateAction<Record<string,Message[]>>>,
): Promise<string | undefined> => {
  let sessionId = localStorage.getItem('goalSessionId')
 
  if (sessionId) return sessionId

  setCanvasData(null)
  setCanvasResponse({})


  const res = await fetch(
    `${process.env.REACT_APP_CARCH_ENDPOINT}/goals/session?user_id=${user_id}&organisation_id=${organisation_id}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    },
  )
  const data = await res.json()

  sessionId = data?.data?.session_id ?? ''
  if (!sessionId) {
    toast.error('Failed to get session_id from server response!')
    setFlow(CAI_CHAT_FLOWS.DEFAULT)
    return
  }
  localStorage.setItem('goalSessionId', sessionId)
  return sessionId
}

export const deleteLocalStorageGoalSession = () => {
  localStorage.removeItem('goalSessionId')
  localStorage.removeItem('goalSessionStatus')
  localStorage.removeItem('goalSessionCanvasResponse')
}
